import React, {Component} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {pathnames as P} from '../../constants/pathnames';

function checkAllowedSharing(WrappedComponent) {
  return class extends Component {
    state = {
      loading: false,
    };

    componentDidMount() {
      this.redirectUnallowedUser();
    };

    componentDidUpdate() {
      this.redirectUnallowedUser();
    };

    redirectUnallowedUser = () => {
      if (!this.checkUserIsAllowed()) {
        this.props.history.replace(P.MAIN_MENU);
      }
    }

    checkUserIsAllowed = () => {
      return this.props.allowInspectionsShare;
    }

    render() {
      const {allowInspectionsShare, ...rest} = this.props;

      return <WrappedComponent {...rest}/>;
    }
  }
}

const mapStateToProps = ({user: {allowInspectionsShare}}) => {
  return {allowInspectionsShare}
};

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    null
  ),
  checkAllowedSharing
);
